
/** @jsx jsx */
import { jsx } from '@emotion/react';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { history } from '../../Helpers/history';
import config from '../../Helpers/config.json';
import * as snackbarActions from '../../Redux/Actions/SnackbarActions/SnackbarActions';
import ReusableDashboardHeader from '../../Containers/Dasboard/ReusableDashboardHeader';
import PharmacySnackbar from '../../Utils/Snackbars/SnackbarUtil';
import { useA4Print } from '../../Utils/Template/useA4Print';
import { errorMessages } from '../../Helpers/ErrorMessages';
import { BackButton } from "../../Utils/Buttons/DataExportationButton";
import A4Receipt from './A4Receipt';

const BigReceiptScreen = ({ actions, snackbars, match: { params } }) => {
  const [data, setData] = useState({ products: [], customer: {} });
  const [loading, setLoading] = useState('idle');
  const { invoice_id, customer_id ,is_dispensar,is_cashier}  = params;
  const disp = is_dispensar === 'true';
  const cash = is_cashier === 'true';
  // useA4Print hook
  const { handlePrint, componentRef, getA4PageMargins, fontSize } = useA4Print('Receipt Full Details ${invoice_id}');


  // Fetch receipt details
  useEffect(() => {
    setLoading('pending');
    const formData = new FormData();
    formData.append('receipt_number', invoice_id);
    formData.append('invoice_number', '');
    formData.append('customer_id', customer_id);

    axios.post(`${config.epharmUrl}/Cinvoice/view_receipt`, formData)
      .then(response => {
        const dt = response.data || {};
        const arr = dt.bill || [];
        const customer_details = dt.customer_details || {};
        setData({ products: arr, customer: { ...customer_details, ...(arr[0] || {}) } });
        setLoading('resolved');
      })
      .catch(error => {
        errorMessages(error, null, actions);
        setLoading('rejected');
      });
  }, [invoice_id, customer_id]);

  const { variant, message, open } = snackbars;
  const { products, customer } = data;

  return (
    <div>
      <ReusableDashboardHeader
        component="Big Invoice"
        heading="Customer Invoice"
        subHeading="Full A4 Invoice"
        link={history.location.pathname}
      />

      <PharmacySnackbar
        open={open}
        variant={variant}
        message={message}
        handleCloseBar={() => actions.snackbarActions.hideSnackBar()}
      />

      <div className="text-right mb-3 mr-5">
        <button onClick={handlePrint} className="btn btn-primary">Print Receipt</button>
      </div>
      <div className="text-left mb-3 mr-5">
          {cash ? (
            <BackButton to="/managependingsale" text="Approve Sales" />
          ) : !disp ? (
        <BackButton to="/sales-receipts" text="Receipts Sales" />
      ) : (
       <BackButton to="/pendingapproval" text="Approved Sales" />
        
        )}

      </div>

      {loading === 'pending' && (
        <div className="text-center mt-5">
          <img src="/images/listPreloader.gif" alt="loader" style={{ width: '10%' }} />
        </div>
      )}

      {loading === 'resolved' && (
        <div ref={componentRef} id="a4Print">
          {/* Inject styles for printing */}
          {/* <style>{getA4PageMargins()}</style>
          <style>{fontSize()}</style> */}

          <A4Receipt  customer={customer} products={products} />
        </div>
      )}

      {loading === 'rejected' && (
        <div className="text-center mt-5">Failed to load Receipt</div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({ snackbars: state.snackbars });
const mapDispatchToProps = dispatch => ({
  actions: { snackbarActions: bindActionCreators(snackbarActions, dispatch) }
});

export default connect(mapStateToProps, mapDispatchToProps)(BigReceiptScreen);
